/// <amd-module name="Wiki/PublishCodeWikiPanel/FolderSelectionDialog" />
import * as React from "react";

import { LegacyComponent } from "VSS/Legacy/Legacy";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { GitRepository } from "Wiki/Clients/VC/Contracts/Git";
import * as Resources from "Wiki/PublishCodeWikiPanel/Resources";

export interface FolderSelectionDialogProps {
    repository: GitRepository;
    friendlyBranchName: string;
    initialPagePath: string;
    onDismiss: () => void;
    onSelected: (version: string) => void;
}

export interface FolderSelectionDialogState {
    error?: Error;
    selectedPagePath: string;
}

export class FolderSelectionDialog extends VssComponent<FolderSelectionDialogProps, FolderSelectionDialogState> {
    constructor(props: FolderSelectionDialogProps, context: IVssComponentContext) {
        super(props, context);

        this.state = {
            selectedPagePath: this.props.initialPagePath
        };
    }

    public render(): JSX.Element {
        return (
            <Dialog
                onDismiss={this.props.onDismiss}
                titleProps={{ text: Resources.SelectFolderLabel }}
                footerButtonProps={[
                    { text: Resources.Cancel, onClick: this.props.onDismiss },
                    {
                        text: Resources.OkLabel,
                        primary: true,
                        disabled: !Boolean(this.state.selectedPagePath),
                        onClick: () => this.props.onSelected(this.state.selectedPagePath)
                    }
                ]}
            >
                {!Boolean(this.props.friendlyBranchName) ? (
                    <MessageCard severity={MessageCardSeverity.Info}>{Resources.NoVersionInRepository}</MessageCard>
                ) : Boolean(this.state.error) ? (
                    <MessageCard severity={MessageCardSeverity.Error}>{this.state.error!.message}</MessageCard>
                ) : (
                    <div className="pcpw-files-tree">
                        <LegacyComponent
                            modules={["Wiki/Scripts/WikiFilesTreeNwpWrapper"]}
                            wrappedType="WikiFilesTreeNwpWrapper"
                            wrappedProps={{
                                repository: this.props.repository,
                                selectedFullPath: this.state.selectedPagePath,
                                branchName: this.props.friendlyBranchName,
                                onItemSelected: this._onItemSelected,
                                onError: this._onError
                            }}
                        />
                    </div>
                )}
            </Dialog>
        );
    }

    private _onItemSelected = (path: string) => {
        this.setState({ selectedPagePath: path });
    };

    private _onError = (error: Error): void => {
        this.setState({ error });
    };
}
